import axios from '../../axios';
import {
   GET_SETUP_FORMATS,
   ADD_SETUP_FORMATS,
   UPDATE_SETUP_FORMATS,
   DELETE_SETUP_FORMATS,
   GET_ONE_SETUP,
   SETUP_FORMAT_CUSTOM_QUERY,
} from '../types';
import { toast } from 'react-toastify';

export const getSetupFormat = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/setupFormat/all', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_SETUP_FORMATS, payload: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const addSetupFormat = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/setupFormat/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_SETUP_FORMATS, payload: res.data.data });
         setTimeout(() => {
            toast.success('Setup Format added successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400 || err.response.status === 500) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateSetupFormat = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/setupFormat/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_SETUP_FORMATS, payload: res.data.data });

         setTimeout(() => {
            toast.success('Setup Format updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400 || err.response.status === 500) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const deleteSetupFormat = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/setupFormat/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_SETUP_FORMATS, payload: { id } });
         toast.success('Setup Format deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Customer. Please try again.');
   }
};

export const getSetupFormatById = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/setupFormat/${params}`);

      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_SETUP, payload: res.data.data, single: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      console.log('err', err.response);
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};

export const setupFormatCustomQuery = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/setupFormat/custom', data);
      if (res.data.code === 1) {
         console.log('res.data. =========', res.data.data);
         dispatch({
            type: SETUP_FORMAT_CUSTOM_QUERY,
            payload: res.data.data,
            customQuery: res.data.data,
            result: res.data.data,
         });
         setTimeout(() => {
            toast.success('Setup Format reset successfully!');
         }, 1000);

         return res.data;
      }

      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);

         return res.data;
      }
   } catch (err) {
      if (err.response.data) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
      return err.response.data;
   }
};
